// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {OrganizationModel} from '@supermove/models';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import MultiDropdownCheckboxInput from '@shared/design/components/Field/MultiDropdownCheckboxInput';

const getRelatedOrganizationsOfficeStaffWithActiveAccountGrantOptions = ({
  organization,
}: {
  organization: OrganizationModel;
}) => {
  const relatedOrganizationsOfficeStaffOptions = _.flatten(
    organization.allCalendarUsers
      .filter((calendarUser) => {
        return !!calendarUser.user.primaryCalendar;
      })
      .map((calendarUser) => {
        return {
          value: _.toNumber(calendarUser.user.id),
          label: calendarUser.user.fullName,
          description: `${calendarUser.user.email}`,
        };
      }),
  );

  const sortedOrgs: {
    value: number | null;
    label: string;
    description: string;
  }[] = _.sortBy(relatedOrganizationsOfficeStaffOptions, ['label']);
  return sortedOrgs;
};

const SalespersonCalendarSelect = ({
  selectedSalesPersonIds,
  organization,
  handleSalesPersonIdsChange,
}: {
  selectedSalesPersonIds: number[];
  organization: OrganizationModel;
  handleSalesPersonIdsChange: (salesPersonIds: number[]) => void;
}) => {
  const salespersonOptions = getRelatedOrganizationsOfficeStaffWithActiveAccountGrantOptions({
    organization,
  });

  return (
    <FieldInput
      index={0}
      label={'Calendars'}
      name={'selectedOptions'}
      component={MultiDropdownCheckboxInput}
      input={{
        options: salespersonOptions,
        value: selectedSalesPersonIds,
        placeholder: `Select calendar(s)`,
        isResponsive: true,
        usePills: true,
        isEnabledSelectAll: true,
        onSelectAll: () => {
          if (selectedSalesPersonIds.length > 0) {
            handleSalesPersonIdsChange([]);
          } else {
            const allSalespersonIds = salespersonOptions
              .filter((option) => option.value !== null)
              .map((option) => option.value) as number[];
            handleSalesPersonIdsChange(allSalespersonIds);
          }
        },
        onChangeValue: (selectedIds: number[]) => {
          handleSalesPersonIdsChange(selectedIds);
        },
      }}
    />
  );
};

SalespersonCalendarSelect.fragment = gql`
  fragment SalespersonCalendarSelect on Organization {
    id
    allCalendarUsers {
      id
      user {
        id
        email
        fullName
        primaryCalendar {
          id
        }
      }
    }
  }
`;

export default SalespersonCalendarSelect;
